module.exports = __webpack_public_path__ + "static/media/flatbread-nav-active.9957f365.svg";